/* AUTO-GENERATED lucide->Hugeicons adapter (@ballerine/ui report templates).
 * Import icons from this module instead of 'lucide-react'.
 * Mapped names render Hugeicons (free, stroke) via <HugeiconsIcon/>. Same
 * component interface as lucide (className, size, strokeWidth, onClick, ...). */
import type { HugeiconsProps, IconSvgElement } from '@hugeicons/react';
import type { LucideIcon, LucideProps } from 'lucide-react';
import { forwardRef } from 'react';
import HI_Activity01Icon from '@hugeicons/core-free-icons/Activity01Icon';
import HI_Activity03Icon from '@hugeicons/core-free-icons/Activity03Icon';
import HI_Alert02Icon from '@hugeicons/core-free-icons/Alert02Icon';
import HI_ArrowDown01Icon from '@hugeicons/core-free-icons/ArrowDown01Icon';
import HI_ArrowLeft01Icon from '@hugeicons/core-free-icons/ArrowLeft01Icon';
import HI_ArrowRight01Icon from '@hugeicons/core-free-icons/ArrowRight01Icon';
import HI_ArrowTurnBackwardIcon from '@hugeicons/core-free-icons/ArrowTurnBackwardIcon';
import HI_ArrowTurnForwardIcon from '@hugeicons/core-free-icons/ArrowTurnForwardIcon';
import HI_ArrowUpDownIcon from '@hugeicons/core-free-icons/ArrowUpDownIcon';
import HI_AuctionIcon from '@hugeicons/core-free-icons/AuctionIcon';
import HI_Book02Icon from '@hugeicons/core-free-icons/Book02Icon';
import HI_Bookmark01Icon from '@hugeicons/core-free-icons/Bookmark01Icon';
import HI_Briefcase01Icon from '@hugeicons/core-free-icons/Briefcase01Icon';
import HI_Building01Icon from '@hugeicons/core-free-icons/Building01Icon';
import HI_Building06Icon from '@hugeicons/core-free-icons/Building06Icon';
import HI_Calendar01Icon from '@hugeicons/core-free-icons/Calendar01Icon';
import HI_Calendar02Icon from '@hugeicons/core-free-icons/Calendar02Icon';
import HI_CalendarRemove01Icon from '@hugeicons/core-free-icons/CalendarRemove01Icon';
import HI_Call02Icon from '@hugeicons/core-free-icons/Call02Icon';
import HI_Cancel01Icon from '@hugeicons/core-free-icons/Cancel01Icon';
import HI_CancelCircleIcon from '@hugeicons/core-free-icons/CancelCircleIcon';
import HI_ChartLineData01Icon from '@hugeicons/core-free-icons/ChartLineData01Icon';
import HI_CheckListIcon from '@hugeicons/core-free-icons/CheckListIcon';
import HI_CheckmarkCircle01Icon from '@hugeicons/core-free-icons/CheckmarkCircle01Icon';
import HI_ConnectIcon from '@hugeicons/core-free-icons/ConnectIcon';
import HI_ContentWritingIcon from '@hugeicons/core-free-icons/ContentWritingIcon';
import HI_Copy01Icon from '@hugeicons/core-free-icons/Copy01Icon';
import HI_CreditCardIcon from '@hugeicons/core-free-icons/CreditCardIcon';
import HI_CropIcon from '@hugeicons/core-free-icons/CropIcon';
import HI_CrownIcon from '@hugeicons/core-free-icons/CrownIcon';
import HI_Database01Icon from '@hugeicons/core-free-icons/Database01Icon';
import HI_Download01Icon from '@hugeicons/core-free-icons/Download01Icon';
import HI_DramaIcon from '@hugeicons/core-free-icons/DramaIcon';
import HI_Factory01Icon from '@hugeicons/core-free-icons/Factory01Icon';
import HI_File01Icon from '@hugeicons/core-free-icons/File01Icon';
import HI_Flag01Icon from '@hugeicons/core-free-icons/Flag01Icon';
import HI_Flag03Icon from '@hugeicons/core-free-icons/Flag03Icon';
import HI_FullScreenIcon from '@hugeicons/core-free-icons/FullScreenIcon';
import HI_GlobalIcon from '@hugeicons/core-free-icons/GlobalIcon';
import HI_Globe02Icon from '@hugeicons/core-free-icons/Globe02Icon';
import HI_HashIcon from '@hugeicons/core-free-icons/HashIcon';
import HI_HierarchyCircle01Icon from '@hugeicons/core-free-icons/HierarchyCircle01Icon';
import HI_Image01Icon from '@hugeicons/core-free-icons/Image01Icon';
import HI_InformationCircleIcon from '@hugeicons/core-free-icons/InformationCircleIcon';
import HI_InternetAntenna01Icon from '@hugeicons/core-free-icons/InternetAntenna01Icon';
import HI_InternetIcon from '@hugeicons/core-free-icons/InternetIcon';
import HI_JusticeScale01Icon from '@hugeicons/core-free-icons/JusticeScale01Icon';
import HI_Link01Icon from '@hugeicons/core-free-icons/Link01Icon';
import HI_LinkSquare02Icon from '@hugeicons/core-free-icons/LinkSquare02Icon';
import HI_Loading03Icon from '@hugeicons/core-free-icons/Loading03Icon';
import HI_Location01Icon from '@hugeicons/core-free-icons/Location01Icon';
import HI_Mail01Icon from '@hugeicons/core-free-icons/Mail01Icon';
import HI_MinusSignIcon from '@hugeicons/core-free-icons/MinusSignIcon';
import HI_Notification01Icon from '@hugeicons/core-free-icons/Notification01Icon';
import HI_NotificationOff01Icon from '@hugeicons/core-free-icons/NotificationOff01Icon';
import HI_PauseIcon from '@hugeicons/core-free-icons/PauseIcon';
import HI_PlayCircleIcon from '@hugeicons/core-free-icons/PlayCircleIcon';
import HI_PlayIcon from '@hugeicons/core-free-icons/PlayIcon';
import HI_PlusSignIcon from '@hugeicons/core-free-icons/PlusSignIcon';
import HI_Profile02Icon from '@hugeicons/core-free-icons/Profile02Icon';
import HI_PropertyNewIcon from '@hugeicons/core-free-icons/PropertyNewIcon';
import HI_RadioIcon from '@hugeicons/core-free-icons/RadioIcon';
import HI_RefreshIcon from '@hugeicons/core-free-icons/RefreshIcon';
import HI_SchemeIcon from '@hugeicons/core-free-icons/SchemeIcon';
import HI_Search01Icon from '@hugeicons/core-free-icons/Search01Icon';
import HI_SecurityCheckIcon from '@hugeicons/core-free-icons/SecurityCheckIcon';
import HI_SecurityValidationIcon from '@hugeicons/core-free-icons/SecurityValidationIcon';
import HI_SecurityWarningIcon from '@hugeicons/core-free-icons/SecurityWarningIcon';
import HI_Share01Icon from '@hugeicons/core-free-icons/Share01Icon';
import HI_StarIcon from '@hugeicons/core-free-icons/StarIcon';
import HI_Store01Icon from '@hugeicons/core-free-icons/Store01Icon';
import HI_Tag01Icon from '@hugeicons/core-free-icons/Tag01Icon';
import HI_ThumbsUpIcon from '@hugeicons/core-free-icons/ThumbsUpIcon';
import HI_Tick02Icon from '@hugeicons/core-free-icons/Tick02Icon';
import HI_TradeDownIcon from '@hugeicons/core-free-icons/TradeDownIcon';
import HI_TradeUpIcon from '@hugeicons/core-free-icons/TradeUpIcon';
import HI_UserGroupIcon from '@hugeicons/core-free-icons/UserGroupIcon';
import HI_UserIcon from '@hugeicons/core-free-icons/UserIcon';
import { HugeiconsIcon } from '@hugeicons/react';

export type { LucideIcon, LucideProps };

type IconProps = Omit<HugeiconsProps, 'icon' | 'altIcon' | 'ref'>;

// Returns a LucideIcon-typed component so these are drop-in replacements for
// every lucide call-site (including ones typed as LucideIcon / passing LucideProps).
const wrap = (icon: IconSvgElement, displayName: string): LucideIcon => {
  const Comp = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
    // `data-icon-name` (BAL-8503) makes the rendered glyph assertable — without it the
    // only way to test 'this row shows the POS icon' is comparing raw SVG path data.
    <HugeiconsIcon
      ref={ref}
      icon={icon}
      strokeWidth={1.5}
      data-icon-name={displayName}
      {...props}
    />
  ));
  Comp.displayName = displayName;

  return Comp as unknown as LucideIcon;
};
export const Activity = wrap(HI_Activity01Icon as unknown as IconSvgElement, 'Activity');
export const Activity03 = wrap(HI_Activity03Icon as unknown as IconSvgElement, 'Activity03');
export const AlertTriangle = wrap(HI_Alert02Icon as unknown as IconSvgElement, 'AlertTriangle');
export const ArrowLeftToLine = wrap(
  HI_ArrowLeft01Icon as unknown as IconSvgElement,
  'ArrowLeftToLine',
);
export const ArrowRight = wrap(HI_ArrowRight01Icon as unknown as IconSvgElement, 'ArrowRight');
export const ArrowRightToLine = wrap(
  HI_ArrowRight01Icon as unknown as IconSvgElement,
  'ArrowRightToLine',
);
export const Auction = wrap(HI_AuctionIcon as unknown as IconSvgElement, 'Auction');
export const BanIcon = wrap(HI_CancelCircleIcon as unknown as IconSvgElement, 'BanIcon');
export const Bell = wrap(HI_Notification01Icon as unknown as IconSvgElement, 'Bell');
export const BellOff = wrap(HI_NotificationOff01Icon as unknown as IconSvgElement, 'BellOff');
export const BookText = wrap(HI_Book02Icon as unknown as IconSvgElement, 'BookText');
export const Bookmark = wrap(HI_Bookmark01Icon as unknown as IconSvgElement, 'Bookmark');
export const Briefcase = wrap(HI_Briefcase01Icon as unknown as IconSvgElement, 'Briefcase');
export const BriefcaseIcon = wrap(HI_Briefcase01Icon as unknown as IconSvgElement, 'BriefcaseIcon');
export const Building = wrap(HI_Building06Icon as unknown as IconSvgElement, 'Building');
export const Building2 = wrap(HI_Building01Icon as unknown as IconSvgElement, 'Building2');
export const BuildingIcon = wrap(HI_Building06Icon as unknown as IconSvgElement, 'BuildingIcon');
export const Calendar = wrap(HI_Calendar01Icon as unknown as IconSvgElement, 'Calendar');
export const Calendar1 = wrap(HI_Calendar01Icon as unknown as IconSvgElement, 'Calendar1');
export const CalendarIcon = wrap(HI_Calendar01Icon as unknown as IconSvgElement, 'CalendarIcon');
export const CalendarSync = wrap(HI_Calendar02Icon as unknown as IconSvgElement, 'CalendarSync');
export const CalendarX2 = wrap(HI_CalendarRemove01Icon as unknown as IconSvgElement, 'CalendarX2');
export const Check = wrap(HI_Tick02Icon as unknown as IconSvgElement, 'Check');
export const CheckCircle2 = wrap(
  HI_CheckmarkCircle01Icon as unknown as IconSvgElement,
  'CheckCircle2',
);
export const CheckIcon = wrap(HI_Tick02Icon as unknown as IconSvgElement, 'CheckIcon');
export const ChevronDown = wrap(HI_ArrowDown01Icon as unknown as IconSvgElement, 'ChevronDown');
export const ChevronRight = wrap(HI_ArrowRight01Icon as unknown as IconSvgElement, 'ChevronRight');
export const ChevronsUpDown = wrap(
  HI_ArrowUpDownIcon as unknown as IconSvgElement,
  'ChevronsUpDown',
);
export const CirclePlay = wrap(HI_PlayCircleIcon as unknown as IconSvgElement, 'CirclePlay');
export const ContentWriting = wrap(
  HI_ContentWritingIcon as unknown as IconSvgElement,
  'ContentWriting',
);
export const Copy = wrap(HI_Copy01Icon as unknown as IconSvgElement, 'Copy');
export const CreditCard = wrap(HI_CreditCardIcon as unknown as IconSvgElement, 'CreditCard');
export const Crop = wrap(HI_CropIcon as unknown as IconSvgElement, 'Crop');
export const Crown = wrap(HI_CrownIcon as unknown as IconSvgElement, 'Crown');
export const Database = wrap(HI_Database01Icon as unknown as IconSvgElement, 'Database');
export const Download = wrap(HI_Download01Icon as unknown as IconSvgElement, 'Download');
export const Drama = wrap(HI_DramaIcon as unknown as IconSvgElement, 'Drama');
export const Earth = wrap(HI_GlobalIcon as unknown as IconSvgElement, 'Earth');
export const ExternalLink = wrap(HI_LinkSquare02Icon as unknown as IconSvgElement, 'ExternalLink');
export const ExternalLinkIcon = wrap(
  HI_LinkSquare02Icon as unknown as IconSvgElement,
  'ExternalLinkIcon',
);
export const Factory = wrap(HI_Factory01Icon as unknown as IconSvgElement, 'Factory');
export const FactoryIcon = wrap(HI_Factory01Icon as unknown as IconSvgElement, 'FactoryIcon');
export const File = wrap(HI_File01Icon as unknown as IconSvgElement, 'File');
export const FileJson2 = wrap(HI_File01Icon as unknown as IconSvgElement, 'FileJson2');
export const FileText = wrap(HI_File01Icon as unknown as IconSvgElement, 'FileText');
export const Flag = wrap(HI_Flag01Icon as unknown as IconSvgElement, 'Flag');
export const FlagTriangleRight = wrap(
  HI_Flag03Icon as unknown as IconSvgElement,
  'FlagTriangleRight',
);
export const Gavel = wrap(HI_JusticeScale01Icon as unknown as IconSvgElement, 'Gavel');
export const Globe = wrap(HI_GlobalIcon as unknown as IconSvgElement, 'Globe');
export const Globe02 = wrap(HI_Globe02Icon as unknown as IconSvgElement, 'Globe02');
export const Hash = wrap(HI_HashIcon as unknown as IconSvgElement, 'Hash');
export const HierarchyCircle01 = wrap(
  HI_HierarchyCircle01Icon as unknown as IconSvgElement,
  'HierarchyCircle01',
);
export const Image = wrap(HI_Image01Icon as unknown as IconSvgElement, 'Image');
export const InfoIcon = wrap(HI_InformationCircleIcon as unknown as IconSvgElement, 'InfoIcon');
export const Internet = wrap(HI_InternetIcon as unknown as IconSvgElement, 'Internet');
export const InternetAntenna01 = wrap(
  HI_InternetAntenna01Icon as unknown as IconSvgElement,
  'InternetAntenna01',
);
export const LineChart = wrap(HI_ChartLineData01Icon as unknown as IconSvgElement, 'LineChart');
export const LinkIcon = wrap(HI_Link01Icon as unknown as IconSvgElement, 'LinkIcon');
export const ListChecks = wrap(HI_CheckListIcon as unknown as IconSvgElement, 'ListChecks');
export const ListChecksIcon = wrap(HI_CheckListIcon as unknown as IconSvgElement, 'ListChecksIcon');
export const Loader2 = wrap(HI_Loading03Icon as unknown as IconSvgElement, 'Loader2');
export const Mail = wrap(HI_Mail01Icon as unknown as IconSvgElement, 'Mail');
export const MailIcon = wrap(HI_Mail01Icon as unknown as IconSvgElement, 'MailIcon');
export const MapPin = wrap(HI_Location01Icon as unknown as IconSvgElement, 'MapPin');
export const MapPinIcon = wrap(HI_Location01Icon as unknown as IconSvgElement, 'MapPinIcon');
export const Maximize2 = wrap(HI_FullScreenIcon as unknown as IconSvgElement, 'Maximize2');
export const Minus = wrap(HI_MinusSignIcon as unknown as IconSvgElement, 'Minus');
export const Network = wrap(HI_ConnectIcon as unknown as IconSvgElement, 'Network');
export const Pause = wrap(HI_PauseIcon as unknown as IconSvgElement, 'Pause');
export const Phone = wrap(HI_Call02Icon as unknown as IconSvgElement, 'Phone');
export const PhoneCall = wrap(HI_Call02Icon as unknown as IconSvgElement, 'PhoneCall');
export const PhoneIcon = wrap(HI_Call02Icon as unknown as IconSvgElement, 'PhoneIcon');
export const Play = wrap(HI_PlayIcon as unknown as IconSvgElement, 'Play');
export const Plus = wrap(HI_PlusSignIcon as unknown as IconSvgElement, 'Plus');
export const Profile02 = wrap(HI_Profile02Icon as unknown as IconSvgElement, 'Profile02');
export const PropertyNew = wrap(HI_PropertyNewIcon as unknown as IconSvgElement, 'PropertyNew');
export const Radio = wrap(HI_RadioIcon as unknown as IconSvgElement, 'Radio');
export const RefreshCcw = wrap(HI_RefreshIcon as unknown as IconSvgElement, 'RefreshCcw');
export const RefreshCw = wrap(HI_RefreshIcon as unknown as IconSvgElement, 'RefreshCw');
export const RotateCcw = wrap(HI_ArrowTurnBackwardIcon as unknown as IconSvgElement, 'RotateCcw');
export const RotateCw = wrap(HI_ArrowTurnForwardIcon as unknown as IconSvgElement, 'RotateCw');
export const Scheme = wrap(HI_SchemeIcon as unknown as IconSvgElement, 'Scheme');
export const ScrollText = wrap(HI_File01Icon as unknown as IconSvgElement, 'ScrollText');
export const SearchCheck = wrap(HI_Search01Icon as unknown as IconSvgElement, 'SearchCheck');
export const SecurityWarning = wrap(
  HI_SecurityWarningIcon as unknown as IconSvgElement,
  'SecurityWarning',
);
export const Share2 = wrap(HI_Share01Icon as unknown as IconSvgElement, 'Share2');
export const ShieldAlert = wrap(
  HI_SecurityValidationIcon as unknown as IconSvgElement,
  'ShieldAlert',
);
export const ShieldCheck = wrap(HI_SecurityCheckIcon as unknown as IconSvgElement, 'ShieldCheck');
export const Star = wrap(HI_StarIcon as unknown as IconSvgElement, 'Star');
export const TagIcon = wrap(HI_Tag01Icon as unknown as IconSvgElement, 'TagIcon');
export const ThumbsUp = wrap(HI_ThumbsUpIcon as unknown as IconSvgElement, 'ThumbsUp');
export const ThumbsUpIcon = wrap(HI_ThumbsUpIcon as unknown as IconSvgElement, 'ThumbsUpIcon');
export const TrendingDown = wrap(HI_TradeDownIcon as unknown as IconSvgElement, 'TrendingDown');
export const TrendingUp = wrap(HI_TradeUpIcon as unknown as IconSvgElement, 'TrendingUp');
export const TriangleAlert = wrap(HI_Alert02Icon as unknown as IconSvgElement, 'TriangleAlert');
export const User = wrap(HI_UserIcon as unknown as IconSvgElement, 'User');
export const Users = wrap(HI_UserGroupIcon as unknown as IconSvgElement, 'Users');
export const UsersIcon = wrap(HI_UserGroupIcon as unknown as IconSvgElement, 'UsersIcon');
export const X = wrap(HI_Cancel01Icon as unknown as IconSvgElement, 'X');
export const XCircle = wrap(HI_CancelCircleIcon as unknown as IconSvgElement, 'XCircle');

/* ── Concept icons (BAL-8503) ───────────────────────────────────────────────
 * Named for the product concept, not the vendor glyph, so "one concept, one
 * icon" is structural instead of a convention repeated at each call site.
 * Re-skinning a concept is a one-line change here; the raw exports above stay
 * for call sites that genuinely want a generic glyph.
 * Keep this block identical in both adapters — `lucide-adapter.unit.test.tsx`
 * fails if a name here resolves to a different glyph across the two packages. */
export const NetworkGraph = wrap(
  HI_HierarchyCircle01Icon as unknown as IconSvgElement,
  'NetworkGraph',
);
export const Ecosystem = wrap(HI_InternetAntenna01Icon as unknown as IconSvgElement, 'Ecosystem');
export const PointOfSale = wrap(HI_Store01Icon as unknown as IconSvgElement, 'PointOfSale');
export const Website = wrap(HI_InternetIcon as unknown as IconSvgElement, 'Website');
export const CompanyDetails = wrap(HI_Profile02Icon as unknown as IconSvgElement, 'CompanyDetails');
